import { config } from 'config';
import { NoCookiesDialog } from '../NoCookiesDialog';
import { useCheckCookieStatus } from './hooks';

export const NoCookiesTracker = () => {
  const { cookiesOn } = useCheckCookieStatus();

  if (config.isElectronBuild || cookiesOn) {
    return null;
  }

  return <NoCookiesDialog />;
};
